import { gql } from '@apollo/client';
import { UpdateWorksheetRowsBySpaceTypePayload } from 'spw-redux/modules/program-summary/programming/types';
import { Scenario } from 'spw-redux/modules/calculators/types';
import { graphqlClient } from './utils';

export const getScenariosContainingSpaceType = (
  projectId: number,
  spaceTypeId: number,
  isChild: boolean
) =>
  graphqlClient.query<{ scenarios: Partial<Scenario>[] }>({
    fetchPolicy: 'no-cache',
    query: gql`
      query GetScenarioIdsContainingSpaceType(
        $projectId: Int
        $spaceTypeId: Int
        $isChild: Boolean
      ) {
        scenarios: getScenariosContainingSpaceType(
          projectId: $projectId
          spaceTypeId: $spaceTypeId
          isChild: $isChild
        ) {
          id
          worksheet {
            id
            spaceAllocation
            rows: worksheetRows {
              id
              child
              quantity
              seatCap
              sizeX
              sizeY
              usf
              ratio
              spaceId
              projectSpaceType {
                id
                previousId
                spaceType {
                  id
                  spaceType
                  name
                  isCustom
                  icon
                }
                category {
                  id
                  name
                  parentId
                  defaultSpaceTypeCategory {
                    id
                    category
                    name
                  }
                }
              }
            }
          }
        }
      }
    `,
    variables: {
      projectId,
      spaceTypeId,
      isChild,
    },
  });

export const updateWorksheetRowsBySpaceType = (
  payload: UpdateWorksheetRowsBySpaceTypePayload
) =>
  graphqlClient.mutate({
    mutation: gql`
      mutation UpdateWorksheetRowsBySpaceType(
        $spaceTypeId: Int!
        $isChild: Boolean!
        $scenarioIds: [Int]!
        $usf: Float
        $seatCap: Int
      ) {
        updateWorksheetRowsBySpaceType(
          scenarioIds: $scenarioIds
          spaceTypeId: $spaceTypeId
          isChild: $isChild
          seatCap: $seatCap
          usf: $usf
        ) {
          id
        }
      }
    `,
    variables: {
      ...payload,
    },
  });
